import { Outlet, Route, Routes } from "react-router-dom";

import PageContent from "components/partials/page-content/page-content";
import { ClientsPage } from "containers/admin/clients/clients-page";
import ProgramTemplatesPage from "containers/admin/clients/client/program-templates-page/program-templates-page";
import A2EProgramsPage from "containers/admin/clients/client/programs-page/a2e-programs-page";
import A2AProgramsPage from "containers/admin/clients/client/programs-page/a2a-programs-page";
import BrandContentGuidelinesPage from "containers/admin/clients/client/brand-content-guidelines-page/brand-content-guidelines-page";
import PartnerPage from "containers/admin/clients/client/partner-page/partner-page";
import CollegeProfilePage from "containers/admin/clients/client/college-profile-page/college-profile-page";
import { AddClientPage } from "containers/admin/clients/add-client-page/add-client-page";
import ClientProvider from "containers/admin/clients/client/components/client-provider/client-provider";
import { ProfileRoutes } from "containers/admin/clients/client/profile-page/profile-routes";
import ThemePage from "containers/admin/clients/client/theme-page/theme-page";
import { CampaignsRoutes } from "containers/admin/clients/client/campaigns-page/campaigns-routes";
import ApprovalQueueRoutes from "containers/admin/clients/client/approval-queue/approval-queue-routes";
import RecentCreativesPage from "containers/admin/recent-creatives/recent-creatives";
import StudentRouterPage from "containers/admin/clients/client/student-router-page/student-router-page";
import { usePagePermission } from "hooks/use-page-permission";

import { Route as AppRoute } from "utilities/app-routes";

import { Permission } from "types/auth";

const ClientsRoutes = () => {
  usePagePermission(Permission.PERM_CLIENT_READ);

  return (
    <Routes>
      <Route index element={<ClientsPage />} />
      <Route path="new" element={<AddClientPage />} />

      <Route
        path=":clientId/*"
        element={
          <ClientProvider>
            <Outlet />
          </ClientProvider>
        }>
        <Route path={AppRoute.recentCreatives + "/*"} element={<RecentCreativesPage />} />
        <Route path={AppRoute.campaigns + "/*"} element={<CampaignsRoutes />} />
        <Route path={AppRoute.partner + "/*"} element={<PartnerPage />} />
        <Route path={AppRoute.collegeProfile + "/*"} element={<CollegeProfilePage />} />
        <Route path={AppRoute.brandGuidelines + "/*"} element={<BrandContentGuidelinesPage />} />
        <Route path={AppRoute.programs}>
          <Route path={AppRoute.a2a + "/*"} element={<A2AProgramsPage />} />
          <Route path={AppRoute.a2e + "/*"} element={<A2EProgramsPage />} />
          <Route index element={<A2EProgramsPage />} />
        </Route>

        <Route path={AppRoute.approvalQueue + "/*"} element={<ApprovalQueueRoutes />} />

        <Route path={AppRoute.theme + "/*"} element={<ThemePage />} />

        <Route
          path={AppRoute.programTemplates + "/*"}
          element={
            <PageContent fixedContent>
              <ProgramTemplatesPage />
            </PageContent>
          }
        />

        <Route path={AppRoute.profile + "/*"} element={<ProfileRoutes />} />
        <Route path={AppRoute.studentRouter + "/*"} element={<StudentRouterPage />} />
      </Route>
    </Routes>
  );
};

export default ClientsRoutes;
